import { useNavigate } from '@remix-run/react'
import SimpleTable from './SimpleTable'
import React from 'react'

type Props = React.ComponentProps<typeof SimpleTable>
export default function NavigableTable(props: Props) {
	const navigate = useNavigate()
	return <SimpleTable {...props} onRowClick={entry => navigate(`/athlete/${entry.athlete}`)} />
}
